import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'parseHttpsLinks',
  pure: true,
  standalone: true,
})
export class ParseHttpsLinksPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string): SafeHtml {
    if (!text || typeof text !== 'string') {
      return text;
    }

    // Match https:// links everywhere, and http://localhost links only
    const urlRegex = /(https:\/\/[^\s]+)|(http:\/\/localhost[^\s]*)/g;

    const result = text.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer" onclick="event.stopPropagation()">${url}</a>`;
    });

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
